import { render, staticRenderFns } from "./Docs.vue?vue&type=template&id=97bafb50"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports